import { render, staticRenderFns } from "./sub-list-primary.vue?vue&type=template&id=ab702d86&"
import script from "./sub-list-primary.vue?vue&type=script&lang=js&"
export * from "./sub-list-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports